import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { ArrowRight, Check, TreePine } from 'lucide-react';
import SEO from '../components/SEO';
import { serviceCategories } from '../data/serviceData';

const AbattageElagage = () => {
  const category = serviceCategories.abattageElagage;

  return (
    <div className="page-category">
      <SEO 
        title={category.seo.title}
        description={category.seo.description}
        keywords={category.seo.keywords}
        canonical={category.slug}
      />
      
      {/* Hero Section */}
      <section className="category-hero">
        <div className="category-hero-bg" style={{ backgroundImage: `url(${category.heroImage})` }}></div>
        <div className="category-hero-overlay"></div>
        <div className="container category-hero-content">
          <div className="category-hero-icon">
            <TreePine size={48} />
          </div>
          <h1 className="display-medium">{category.title}</h1>
          <p className="body-large">{category.description}</p>
          <Link to="/contact" className="btn-cta">
            Demander une soumission gratuite
            <ArrowRight size={20} style={{ marginLeft: '8px' }} />
          </Link>
        </div>
      </section>

      {/* Services Grid */}
      <section className="category-services-section">
        <div className="container">
          <h2 className="heading-1 section-title">Nos services d'arboriculture</h2>
          <p className="body-large section-subtitle">
            Des solutions professionnelles pour tous vos besoins d'entretien et d'abattage d'arbres à Québec et dans la Capitale-Nationale.
          </p>
          
          <div className="services-detailed-grid">
            {category.services.map((service, index) => (
              <div key={service.id} className="service-detailed-card" id={service.id}>
                <div className="service-detailed-image">
                  <img src={service.image} alt={service.title} loading="lazy" />
                </div>
                <div className="service-detailed-content">
                  <h3 className="heading-2">{service.title}</h3>
                  <p className="body-medium">{service.description}</p>
                  
                  <div className="service-benefits">
                    <h4 className="benefits-title">Avantages</h4>
                    <ul className="benefits-list">
                      {service.benefits.map((benefit, i) => (
                        <li key={i}>
                          <Check size={16} className="benefit-icon" />
                          <span>{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                  
                  <Link to="/contact" className="btn-secondary service-cta-btn">
                    Demander une soumission
                    <ArrowRight size={18} style={{ marginLeft: '8px' }} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="category-gallery-preview">
        <div className="container">
          <h2 className="heading-1 section-title">Nos réalisations</h2>
          <p className="body-large section-subtitle">
            Découvrez quelques exemples de nos travaux d'abattage et d'élagage réalisés dans la région de Québec.
          </p>
          <div className="gallery-preview-cta">
            <Link to="/realisations" className="btn-secondary">
              Voir toutes nos réalisations
              <ArrowRight size={18} style={{ marginLeft: '8px' }} />
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="category-cta-section">
        <div className="container">
          <div className="cta-content">
            <h2 className="heading-1">Besoin d'un service d'arboriculture?</h2>
            <p className="body-large">
              Contactez-nous pour une évaluation gratuite de votre projet. Notre équipe d'experts est prête à vous aider.
            </p>
            <div className="cta-buttons">
              <Link to="/contact" className="btn-cta">
                Demander une soumission gratuite
                <ArrowRight size={20} style={{ marginLeft: '8px' }} />
              </Link>
              <a href={`tel:+15147144245`} className="btn-secondary">
                Appelez-nous maintenant
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AbattageElagage;
